// src/pages/kpis/KpiOutrosPage.jsx
import React, { useState } from "react";

import LayoutDesktop from "../../layouts/LayoutDesktop";
import LayoutMobile from "../../layouts/LayoutMobile";
import { useTheme } from "../../contexts/ThemeContext";
import { useIsMobile } from "../../hooks/useIsMobile";

export default function KpiOutrosPage() {
  const { tema, alterarTema } = useTheme();
  const isMobile = useIsMobile(900);
  const [sidebarAberta, setSidebarAberta] = useState(false);

  const conteudo = (
    <section style={{ width: "100%" }}>
      <div className="pc-card" style={{ width: "100%" }}>
        <header className="pc-table-header">
          <div className="pc-table-header-text">
            <h3>Outros KPIs</h3>
            <p>Espaço reservado para novos indicadores (ex.: Disponibilidade, Backlog, SLA, Refugo por OS, etc.).</p>
          </div>
        </header>

        <div className="pc-card" style={{ padding: 12 }}>
          <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.6 }}>
            <li>Disponibilidade por máquina (paradas x tempo no período)</li>
            <li>Backlog (OS abertas por criticidade / idade)</li>
            <li>MTTA (tempo médio até iniciar atendimento)</li>
            <li>Lead time do pedido (pedido → recebimento)</li>
          </ul>
        </div>
      </div>
    </section>
  );

  return isMobile ? (
    <LayoutMobile
      tema={tema}
      alterarTema={alterarTema}
      titulo="KPIs — Outros"
      sidebarAberta={sidebarAberta}
      onToggleSidebar={() => setSidebarAberta((prev) => !prev)}
    >
      {conteudo}
    </LayoutMobile>
  ) : (
    <LayoutDesktop tema={tema} titulo="KPIs" subtitulo="Outros">
      {conteudo}
    </LayoutDesktop>
  );
}
